import { Component, OnInit, Input, AfterViewInit, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { NoteService } from '../../services/note.service';

import { RepayScheduleListItem } from 'src/app/models/note';

@Component({
  selector: 'app-note-repay-schedule-list',
  templateUrl: './note-repay-schedule-list.component.html',
  styleUrls: ['./note-repay-schedule-list.component.scss']
})
export class NoteRepayScheduleListComponent implements OnInit, AfterViewInit {
  private _noteId = 0;

  @Input()
  set noteId(noteId: number) {
    this._noteId = noteId || 0;
    this.getData();
  }
  get noteId(): number {
    return this._noteId;
  }

  // Have to use the following ElementDisplayStyle variables and ngStyle to show/hide table elements
  // This because the table paginator will not attach correctly otherwise - this is a work around for a known issue
  private _hideElementDisplayStyle = 'none';
  private _showElementDisplayStyle = 'inline';
  private _showElementDisplayStyleIE = 'inline-block';

  private _handleError: HandleError;
  private _logging = environment.logging;
  private var_total_payments = 0;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  showSpinner = false;

  notesRepayScheduleList: (RepayScheduleListItem)[] = [];

  // DataTable
  tableDisplayedColumns = ['numberOfPayments', 'paymentAmount', 'effectiveDate'];
  tableDataSource = new MatTableDataSource<RepayScheduleListItem>(this.notesRepayScheduleList);
  tableDisplayStyle: string = this._hideElementDisplayStyle;
  tableDisplayStyleIE: string = this._hideElementDisplayStyle;
  notesRepayScheduleListFound = false;

  constructor(private _errorHandler: ErrorHandler, private _noteService: NoteService, public media: MediaObserver) {
    this._handleError = _errorHandler.createHandleError('NoteRepayScheduleListComponent');
  }

  ngOnInit() {
    this.notesRepayScheduleListFound = true;
    this.tableDisplayStyle = this.notesRepayScheduleListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
    this.tableDisplayStyleIE = this.notesRepayScheduleListFound ? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;
  }

  ngAfterViewInit() {}

  getData(): void {
    this.showSpinner = true;
    this.getNotesRepayScheduleList(this._noteId);
  }

  getNotesRepayScheduleList(noteId: number): void {
    this.showSpinner = true;
    this.var_total_payments = 0;
    this._noteService.getNoteRepayScheduleList(noteId).subscribe(
      resultArray => {
        this.notesRepayScheduleList = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('NoteRepayScheduleListComponent.getNotesRepayScheduleList :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('NoteRepayScheduleListComponent.getNotesRepayScheduleList :: result = ' + JSON.stringify(resultArray));
        }

        this.tableDataSource = new MatTableDataSource<RepayScheduleListItem>(this.notesRepayScheduleList);
        this.notesRepayScheduleListFound = resultArray.length > 0;
        this.tableDisplayStyle = this.notesRepayScheduleListFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
        this.tableDisplayStyleIE = this.notesRepayScheduleListFound ? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;

        this.notesRepayScheduleList.forEach(row => {
          // Calculate the sum of each row
          //row.numberOfPayments
            this.var_total_payments += row.numberOfPayments;
          });
        this.getDataComplete();
      },
      error => this._handleError('getNotesRepayScheduleList', error)
    );
  }

  getDataComplete(): void {
    this.showSpinner = false;
  }
}
